// Presentation rows never become model bindings or runtime pricing versions.
export function catalogRate(item, metric) {
  const rate = item.rates?.find((entry) => entry.metric === metric);
  if (!rate) return null;
  const match = /^(\d+)(?:\.(\d+))?$/.exec(String(rate.price));
  if (!match) return null;
  let [, whole, fraction = ""] = match;
  if (metric === "web_search_requests") {
    if (rate.unit === "request") {
      const digits = (whole + fraction).padEnd(whole.length + 3, "0");
      const point = whole.length + 3;
      whole = digits.slice(0, point);
      fraction = digits.slice(point);
    } else if (rate.unit !== "thousand_requests") return null;
  } else if (rate.unit !== "million_tokens") return null;
  whole = BigInt(whole).toString();
  fraction = fraction.replace(/0+$/, "");
  return fraction ? `${whole}.${fraction}` : whole;
}

export function modelPriceRows(prices, includeDiscounts = false) {
  const rows = prices.flatMap((item) => {
    const row = { ...item, catalogRowId: item.pricingVersionId };
    if (!includeDiscounts || item.provider !== "deepseek" ||
        !item.pricingVersionId?.startsWith("triproutes-official-deepseek-")) return [row];
    return [{ ...row, catalogRowId: `${row.catalogRowId}:offpeak`, tariffLabel: "Вне пиковых часов · справочно",
      rates: item.rates.map((rate) => ({ ...rate, price: String(Number(rate.price) / 2) })) },
    { ...row, tariffLabel: "Пиковые часы · ставка расчёта Harness" }];
  });
  const price = (item, metric) => {
    const value = item.rates?.find((rate) => rate.metric === metric && rate.unit === "million_tokens");
    return value && Number.isFinite(Number(value.price)) ? Number(value.price) : Infinity;
  };
  return rows.sort((a, b) => a.currency.localeCompare(b.currency) ||
    price(a, "input_tokens") - price(b, "input_tokens") ||
    price(a, "output_tokens") - price(b, "output_tokens") ||
    a.provider.localeCompare(b.provider) || a.model.localeCompare(b.model));
}

export function modelSearchNote(item) {
  if (item.provider === "deepseek") return "Через внешние API · оплачивается отдельно";
  if (item.provider === "kimi") return item.counterpartySelection?.webSearch
    ? "Поиск Kimi · расчёт по тарифу каталога"
    : "$web_search · используемый API";
  if (item.provider === "anthropic") return "Встроенный поиск · оплачивается отдельно";
  return "web_search · без preview";
}
